import { useState } from "react";
import Header from "../Header";
import { Spinner } from 'react-bootstrap';

const Greetings = () => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        festival: '',
        s_date: '',
        r_date: ''
    });
    const role = localStorage.getItem('role');
    const id = localStorage.getItem('userId');


    const [successMessage, setSuccessMessage] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSuccessMessage('');
         const payload = {
            ...formData,
            role: role,
            mgr_id: id
        };

        console.log(payload);

        try {
            const response = await fetch("https://apiaksharaconnect.aksharafinalytics.in/Greeting", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                setSuccessMessage("Message sent successfully!");
                setFormData({
                    festival: '',
                    s_date: '',
                    r_date: ''
                });

                setTimeout(() => setSuccessMessage(''), 3000); // auto-dismiss
            } else {
                setSuccessMessage("Something went wrong. Please try again.");
            }

        } catch (error) {
            setSuccessMessage("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />
            <div className="container mt-5">
                {successMessage && <div className="alert alert-success text-center">{successMessage}</div>}

                <div className="card shadow">
                    <div className="card-header">
                        <h2>Greetings SMS</h2>
                    </div>

                    <div className="card-body">
                        {loading ? (
                            <div className="text-center my-5">
                                <Spinner animation="border" role="status" />
                                <div className="mt-3">Submitting message...</div>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                <input type="hidden" name="role" value={role}/>
                                <input type="hidden" name="mgr_id" value={id}/>
                                <div className="mb-3">
                                    <label className="form-label">Festival</label>
                                    <select className="form-control" name="festival" value={formData.festival} onChange={handleChange} required>
                                        <option value="">Select a Festival</option>
                                        <option value="newyear">New Year</option>
                                        {/* <option value="sankranti">Sankranti</option>
                                        <option value="republicday">Republic Day</option> */}
                                        <option value="mahashivaratri">Maha Shivaratri</option>
                                        {/* <option value="holi">Holi</option>
                                        <option value="goodfriday">Good Friday</option>
                                        <option value="ramzan">Ramzan</option>
                                        <option value="sriramnavami">Sri Rama Navami</option>
                                        <option value="mayday">May Day</option>
                                        <option value="independenceday">Independence Day</option>
                                        <option value="vinayakachaturthi">Vinayaka Chaturthi</option>
                                        <option value="dussehra">Dussehra</option>
                                        <option value="diwali">Diwali</option>
                                        <option value="christmasday">Christmas Day</option> */}
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Start Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="s_date"
                                        value={formData.s_date}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Reopen Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="r_date"
                                        value={formData.r_date}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="text-center">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        Send Message
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Greetings;
